import React, { useState, useEffect, useRef } from 'react';

function KustomReceipt({ htmlSnippet, loadingFinished = null }) {
  const [showLoading, setShowLoading] = useState(true);

  const containerRef = useRef(null);

  useEffect(() => {
    if (!htmlSnippet) return;
    (async () => {
      const container = containerRef.current;
      container.innerHTML = htmlSnippet;

      const scriptTags = container.getElementsByTagName('script');

      for (let i = 0; i < scriptTags.length; i++) {
        const parent = scriptTags[i].parentNode;
        const newScript = document.createElement('script');
        newScript.type = 'text/javascript';
        if (scriptTags[i].src) {
          newScript.src = scriptTags[i].src;
        } else {
          newScript.text = scriptTags[i].text;
        }
        parent.removeChild(scriptTags[i]);
        parent.appendChild(newScript);
      }
      setShowLoading(false);
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      loadingFinished && loadingFinished();
    })();
  }, [htmlSnippet]);

  return (
    <div className="payment-container">
      <div id="payment-view" className="px-5 py-4" style={{ border: '1px solid #ccc', borderRadius: '5px' }}>
        <div className="row">
          <div className="col" style={{ minHeight: 400 }}>
            {showLoading && (
              <div className="spinner" style={{ marginBottom: '30px' }}>
                <div className="dot1" />
                <div className="dot2" />
              </div>
            )}
            <div ref={containerRef} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default KustomReceipt;
